import zones from '@/config/body-map-zones.json'
import es from '@/lang/locals/es.json'
import en from '@/lang/locals/en.json'

const ANSWER_PATTERN = /^(.+?)\s*\((\d+)\)\s*$/

const normalize = (value) => String(value || '').trim().toLowerCase()

const zoneIdByLabel = [es, en].reduce((map, locale) => {
    const parts = locale?.questions?.bodyMap?.parts || {}
    const sides = locale?.questions?.bodyMap?.sides || {}
    zones.forEach(zone => {
        const part = parts[zone.key]
        if (!part) return
        const label = zone.side ? `${part} ${sides[zone.side] || ''}` : part
        map[normalize(label)] = zone.id
    })
    return map
}, {})

export const parseBodyZones = (bodyItem) => {
    const result = {}

    if (bodyItem?.zones && typeof bodyItem.zones === 'object') {
        Object.entries(bodyItem.zones).forEach(([id, level]) => {
            const value = Number(level)
            if (Number.isFinite(value) && value > 0) result[id] = value
        })
        return result
    }

    const groups = Array.isArray(bodyItem?.value) ? bodyItem.value : []
    groups.forEach(group => {
        const values = Array.isArray(group?.values) ? group.values : []
        values.forEach(entry => {
            const match = ANSWER_PATTERN.exec(String(entry || ''))
            if (!match) return
            const id = zoneIdByLabel[normalize(match[1])]
            if (!id) return
            result[id] = Number(match[2])
        })
    })
    return result
}

export const parseAdvanceBodyZones = (advance) => {
    const result = {}
    ;(advance?.preSummary || [])
        .filter(item => item?.type === 'body')
        .forEach(item => Object.assign(result, parseBodyZones(item)))
    return result
}
